import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ApiService } from './api.service';
import { getResponseData } from '../models/api-response.model';
import { PopupAdDto } from '../models/popup-ad.model';

@Injectable({
  providedIn: 'root',
})
export class PopupAdService {
  constructor(private api: ApiService) {}

  getActivePopup(): Observable<PopupAdDto | null> {
    return this.api.get<PopupAdDto>('PopupAds/GetActivePopup').pipe(
      map((response) => getResponseData(response, null)),
      catchError(() => of(null))
    );
  }
}
